import setMedicationDelivery from './setMedicationDelivery';
import setMedicationDeliveries from './setMedicationDeliveries';

export default { setMedicationDelivery, setMedicationDeliveries };
